import * as Mod1 from "./discourse/adapters/discourse-reactions-adapter";
import * as Mod2 from "./discourse/adapters/discourse-reactions-custom-reaction";
import * as Mod3 from "./discourse/components/discourse-reactions-actions-button";
import * as Mod4 from "./discourse/components/discourse-reactions-actions-summary";
import * as Mod5 from "./discourse/components/discourse-reactions-actions";
import * as Mod6 from "./discourse/components/discourse-reactions-counter";
import * as Mod7 from "./discourse/components/discourse-reactions-double-button";
import * as Mod8 from "./discourse/components/discourse-reactions-list-emoji";
import * as Mod9 from "./discourse/components/discourse-reactions-list";
import * as Mod10 from "./discourse/components/discourse-reactions-picker";
import * as Mod11 from "./discourse/components/discourse-reactions-reaction-button";
import * as Mod12 from "./discourse/components/discourse-reactions-reaction-emoji";
import * as Mod13 from "./discourse/components/discourse-reactions-state-panel-reaction";
import * as Mod14 from "./discourse/components/discourse-reactions-state-panel";
import * as Mod15 from "./discourse/components/discourse-reactions-users-menu";
import * as Mod16 from "./discourse/connectors/user-activity-bottom/discourse-reactions-user-activity-reactions.gjs";
import * as Mod17 from "./discourse/connectors/user-notifications-bottom/discourse-reactions-user-notification-reactions.gjs";
import * as Mod18 from "./discourse/controllers/user-activity/reactions";
import * as Mod19 from "./discourse/discourse-reactions-user-activity-route-map";
import * as Mod20 from "./discourse/discourse-reactions-user-notifications-route-map";
import * as Mod21 from "./discourse/initializers/discourse-reactions";
import * as Mod22 from "./discourse/initializers/reactions-admin-plugin-configuration-nav";
import * as Mod23 from "./discourse/lib/hidden-post";
import * as Mod24 from "./discourse/models/discourse-reactions-custom-reaction";
import * as Mod25 from "./discourse/routes/user-activity/reactions";
import * as Mod26 from "./discourse/routes/user-notifications/reactions-received";
import * as Mod27 from "./discourse/templates/user-activity/reactions";
const compatModules = {
  "discourse/adapters/discourse-reactions-adapter": Mod1,
  "discourse/adapters/discourse-reactions-custom-reaction": Mod2,
  "discourse/components/discourse-reactions-actions-button": Mod3,
  "discourse/components/discourse-reactions-actions-summary": Mod4,
  "discourse/components/discourse-reactions-actions": Mod5,
  "discourse/components/discourse-reactions-counter": Mod6,
  "discourse/components/discourse-reactions-double-button": Mod7,
  "discourse/components/discourse-reactions-list-emoji": Mod8,
  "discourse/components/discourse-reactions-list": Mod9,
  "discourse/components/discourse-reactions-picker": Mod10,
  "discourse/components/discourse-reactions-reaction-button": Mod11,
  "discourse/components/discourse-reactions-reaction-emoji": Mod12,
  "discourse/components/discourse-reactions-state-panel-reaction": Mod13,
  "discourse/components/discourse-reactions-state-panel": Mod14,
  "discourse/components/discourse-reactions-users-menu": Mod15,
  "discourse/connectors/user-activity-bottom/discourse-reactions-user-activity-reactions": Mod16,
  "discourse/connectors/user-notifications-bottom/discourse-reactions-user-notification-reactions": Mod17,
  "discourse/controllers/user-activity/reactions": Mod18,
  "discourse/discourse-reactions-user-activity-route-map": Mod19,
  "discourse/discourse-reactions-user-notifications-route-map": Mod20,
  "discourse/initializers/discourse-reactions": Mod21,
  "discourse/initializers/reactions-admin-plugin-configuration-nav": Mod22,
  "discourse/lib/hidden-post": Mod23,
  "discourse/models/discourse-reactions-custom-reaction": Mod24,
  "discourse/routes/user-activity/reactions": Mod25,
  "discourse/routes/user-notifications/reactions-received": Mod26,
  "discourse/templates/user-activity/reactions": Mod27,
};
export default compatModules;
